<template>
  <div class="wrapper">
    <p class="title">Change my photo</p>
    <div class="content">
      <!-- user img  -->
      <div class="user-img">
        <div class="overlay">
          <image-uploader
            outputFormat="verbose"
            :debug="1"
            :maxWidth="3000"
            :maxHeight="2688"
            :quality="0.7"
            :preview="false"
            :autoRotate="true"
            :className="['fileinput', { 'fileinput--loaded': hasImage }]"
            :capture="false"
            accept="image/*"
            @input="setImage"
            @onUpload="startImageResize"
            @onComplete="endImageResize"
          >
            <label for="fileInput" slot="upload-label">
              <div class="d-flex align-items-center">
                <b-avatar
                  v-if="!imgSpinner"
                  :variant="imageToDisplay ? 'light' : 'secondary'"
                  class="user-avatar"
                  :src="imageToDisplay"
                />
                <b-spinner
                  class="spinner-grow"
                  v-else
                  type="grow"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <i class="mdi mdi-camera upload-icon"></i>
              </div>
            </label>
          </image-uploader>
        </div>
      </div>
      <!-- update checkbox  -->
      <div class="form-groups text-center entity-checkbox" v-if="getUserData.is_system_user">
        <b-form-checkbox
          id="checkbox-1"
          v-model="form.update_cloud"
          name="cascade"
        >
          Update my photo on all my companies
        </b-form-checkbox>
      </div>
      <!-- action btns  --> 
      <hr class="h-line" />
      <div class="action-btns">
        <button v-if="getUserData.is_system_user"
          class="submit-btn btn btn-primary"
          size="md"
          v-on:click="submitFile()"
          :disabled="getLoading || !imageToDisplay  || (!hasImage && !getUserData.image )  || (!form.update_cloud && !hasImage) || (!form.update_cloud && !getUserData.image && !hasImage)"
        >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>Update</span>
        </button>
         <button v-else
          class="submit-btn btn btn-primary"
          size="md"
          v-on:click="submitFile()"
          :disabled="getLoading  || !hasImage"
          >
          <i
            v-if="getLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
          ></i>
          <span v-else>Update</span>
        </button>
        <button
          class="btn btn-outline-danger"
          @click="$bvModal.hide('userProfile')"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import ImageUploader from "vue-image-upload-resize";

export default {
  components: { ImageUploader },
  data() {
    return {
      submitted: false,
      file: null,
      form: {
        update_cloud: false,
      },
      imageSizeError: "",
      baseURL: process.env.VUE_APP_S3_URL,
      getLoading: false,
      imageToDisplay: null,
      hasImage: false,
      imgSpinner: false,
    };
  },
  validations: {
    file: { required },
  },
  watch: {
    file(imgObj) {
      if (typeof imgObj == "object") {
        if (imgObj.size > 2000000) {
          this.imageSizeError =
            "can not upload an image because it is too big, the size should be less than 2.5 Mb";
        } else {
          this.imageSizeError = "";
        }
        this.imageToDisplay = URL.createObjectURL(imgObj);
      }
    },
    getModalState(state) {
      state && this.$bvModal.hide("userProfile");
    },
  },
  computed: {
    ...mapGetters("user", ["getUserNewImage", "getUserData"]),
  },
  methods: {
    ...mapActions("user", ["saveUserQr"]),

    dataURLtoFile(dataUrl, fileName) {
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },
    setImage: function(output) {
      if (output.info.orgHeight <= 300 || output.info.orgWidth <= 250) {
        this.imgMinSizeErr = true;
      } else {
        this.imgMinSizeErr = false;
        this.hasImage = true;
        const obj = this.dataURLtoFile(output.dataUrl, output.info.name);
        this.file = obj;
      }
    },
    startImageResize() {
      this.imgSpinner = true;
    },
    endImageResize() {
      this.imgSpinner = false;
    },
    submitFile() {
      this.getLoading = true;
      let formData = new FormData();
      const user = JSON.parse(localStorage.getItem("user"));
      formData.append("file", this.file);
      formData.append("userId", user.data.user.id);
      formData.append("update_cloud", Number(this.form.update_cloud));
      axios
        .post(`${process.env.VUE_APP_BASE_URL}/api/change-image`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${user.data.access_token}`,
          },
        })
        .then((data) => {
          if (data.data.data.status == "1") {
            this.$store.dispatch(
              "user/saveUserNewImage",
              data.data.data.imgName
            );
            this.$toast.success("Image Updated");
            this.getLoading = false;
            this.$bvModal.hide('userProfile')
            this.saveUserQr(data.data.data.qr_url);
          } else {
            this.$toast.error(data.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            this.$toast.error(err.response.data.message);
            this.getLoading = false;
          }
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
  beforeMount() {
    let user = JSON.parse(localStorage.getItem("user"));
    let userImage = `${this.baseURL}/${user.data.user.image}`;
    this.imageToDisplay =
      userImage && this.getUserNewImage == null
        ? userImage
        : `${process.env.VUE_APP_S3_URL}/${this.getUserNewImage}`;
  },
};
</script>

<style lang="scss" scoped>
.user-img {
  display: flex;
  justify-content: center;
  .overlay {
    transition: opacity 0.5s ease;
    -webkit-transition: opacity 0.5s ease;
    -moz-transition: opacity 0.5s ease;
    position: relative;
    border-radius: 50%;
    z-index: 1;
    margin-bottom: 33px;
    &::after {
      content: "\A";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      transition: opacity 0.5s;
      -webkit-transition: opacity 0.5s;
      -moz-transition: opacity 0.5s;
    }
    &:hover {
      &::after {
        opacity: 1;
      }
      .upload-icon {
        display: block;
      }
    }
    div {
      height: 106px;
      .user-avatar,
      .spinner-grow {
        width: 106px;
        height: 106px;
      }
      label {
        margin-bottom: 0px;
      }
    }
  }
  .upload-icon {
    cursor: pointer;
    transition: 0.5s;
    display: none;
    cursor: pointer;
    color: #ffffff;
    opacity: 0.65;
    font-size: 2.5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
    transform: translate(-50%, -50%);
  }
}
</style>
